<template>
  <div v-if="isOrgAdmin">
    <error-dialog :status="toggleStatus" />

    <v-menu :top="!bottom" :bottom="bottom" offset-y v-model="isOpen">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" :icon="!fab" :fab="fab" :small="small" :disabled="disabled || [ blankDesignId, nullCoverDesignId ].includes(targetId)">
          <v-icon v-html="mdiCog" />
        </v-btn>
      </template>
      <v-card class="pa-3" width="280">
        <div class="overline short mt-n1 mb-n2">Organization tools</div>
        <v-checkbox
          hide-details readonly label="Include this design in your organization's private catalog"
          :disabled="loadStatus.pending || toggleStatus.pending"
          :input-value="hasOrgTag"
          @click="toggle"
        />
        <div class="text--label-active mt-4">Your changes may take up to 15 minutes to take effect</div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import ErrorDialog from '@/components/ErrorDialog.vue';
import { publicDesign } from '@/mixins/public-design.js';
import { mdiCog, mdiDownload, mdiTag, mdiTrophy } from '@mdi/js';

export default {
  name: 'design-org-admin-btn',

  mixins: [ publicDesign ],

  components: {
    ErrorDialog
  },

  props: [ 'scope', 'targetId', 'disabled', 'fab', 'small', 'bottom' ],

  data() {
    return {
      hasOrgTag: false,
      isOpen: false,
      loadStatus: this.$track('load'),
      toggleStatus: this.$track('toggle')
    };
  },

  computed: {
    isOrgAdmin() {
      return !!(this.global.profile && this.global.profile.org_admin);
    }
  },

  created() {
    Object.assign(this, { mdiCog, mdiDownload, mdiTag, mdiTrophy });
  },

  methods: {
    async load() {
      this.hasOrgTag = await this.$call('has-org-tag', { target_id: this.targetId, scope: this.scope });
    },

    async toggle() {
      await this.$call('set-org-tag', { target_id: this.targetId, value: !this.hasOrgTag, scope: this.scope });
      this.hasOrgTag = !this.hasOrgTag;
    }
  },

  watch: {
    targetId: {
      immediate: true,
      handler() {
        this.load();
      }
    }
  }
}
</script>
